export default function SubcontextoOrderByDefaultAndAlphabetically() {
    const DEFAULT_CONTEXT_VALUE = '0';

    return function (input, subcontextNameProperty, subcontextIdProperty) {
        if (!input || !Array.isArray(input)) {
            return input;
        }

        subcontextNameProperty = subcontextNameProperty || 'name';
        subcontextIdProperty = subcontextIdProperty || 'id';

        const defaultContext = input.find(item => isDefaultContext(item[subcontextIdProperty]));

        const otherContexts = input
            .filter(item => !isDefaultContext(item[subcontextIdProperty]))
            .sort((a, b) => {
                const aName = (a[subcontextNameProperty] || '').toLowerCase();
                const bName = (b[subcontextNameProperty] || '').toLowerCase();
                return aName.localeCompare(bName);
            });

        return defaultContext ? [defaultContext, ...otherContexts] : otherContexts;
    };

    function isDefaultContext(value) {
        return value === DEFAULT_CONTEXT_VALUE;
    }
}

SubcontextoOrderByDefaultAndAlphabetically.$inject = []; 